export default __webpack_public_path__ + "static/media/seattle.a1d747a0.png";